import { facadeApi } from 'api'
import { AzV2Group } from 'types/groups/groups'

interface Params {
  groupId: string
}

export const fetchGroupApi = ({ groupId }: Params) => facadeApi.get<AzV2Group>(`/az/v2/groups/${groupId}`)
